// extracted by mini-css-extract-plugin
export default {"bankIdLogo":"bankIdLogo--kM1WY","inProgress":"inProgress--CSZzB","minHeight":"minHeight--YIxKy"};